import React, { FC, useState } from 'react';

import { IEvButtonProps } from '@evinced-private/ui-common';

import { validateProperty } from '../../helpers/FormHelper';
import { PropertyHelper } from '../../helpers/PropertyHelper';
import { isPropertyInListMode } from '../../helpers/PropertySourceHelper';
import { IProperty } from '../../interfaces/Property';
import { useNotifications } from '../../providers/notificationsProvider/NotificationsConsumer';
import { createPropertyFromJSON } from '../../services/PropertiesService';
import { JsonPopup } from '../json-popup/JsonPopup';

interface ICreatePropertyFromJsonPopupProps {
	triggerButtonProps: IEvButtonProps;
	onPropertyCreated: (propertyId: string) => void;
}

export const CreatePropertyFromJsonPopup: FC<ICreatePropertyFromJsonPopupProps> = ({
	triggerButtonProps,
	onPropertyCreated
}) => {
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [errors, setErrors] = useState<string[]>([]);

	const { alert } = useNotifications();

	const onSave = (propertyToSave: IProperty, close: () => void): void => {
		const isInListMode = isPropertyInListMode(propertyToSave?.urlSetConfiguration?.source);
		const formErrors = validateProperty(propertyToSave, isInListMode);

		if (formErrors.length) {
			setErrors(formErrors.map((e) => e.message));
			return;
		}
		setErrors([]);
		setIsLoading(true);
		createPropertyFromJSON(propertyToSave)
			.then((data) => {
				close();
				onPropertyCreated(data.id);
			})
			.catch((err) => {
				alert({ errorMessage: 'Error creating property.', serverError: err });
				setIsLoading(false);
			});
	};

	return (
		<JsonPopup
			title="Create Property"
			initialValue={PropertyHelper.getDefaultPropertyFromTemplate('https://www.example.com')}
			approveButtonText="Save"
			onApprove={onSave}
			triggerButtonProps={triggerButtonProps}
			isLoading={isLoading}
			errors={errors}
		/>
	);
};
